import { tokens } from "@manifesthhqinc/ui-library";
import styled from "styled-components";

export const NotificationBarContainer = styled.div`
  border-radius: 5px;
  width: 100%;
  padding: 14px;
  background: ${tokens.color.brand[50]};
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 24px;
`;

export const NotificationBarIcon = styled.div<{ $isButton?: boolean }>`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    props.$isButton &&
    `cursor: pointer;
    path {
    stroke: ${tokens.color.neutral[600]}`}
`;

export const NotificationBarContent = styled.div`
  font-size: 13px;
  line-height: 21px;
  color: ${tokens.color.text[1000]};

  button {
    color: ${tokens.color.brand[700]};
    text-decoration: underline;
    cursor: pointer;
    font-weight: 500;
  }
`;
